import { getLastIndex } from './array'
import { QUESTION_TYPES, LANGUAGES } from './constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const DEFAULT_ADVANCED_OPTIONS_GROUPS = {
  randomize_questions: null,
  max_questions_to_show: null,
}

export const groupAdvancedOptionsToRenderConfig = {
  randomize_questions: {
    type: 'boolean',
    displayText: {
      [PORTUGUESE]: 'Perguntas Aleatórias:',
      [ENGLISH]: 'Randomize Questions:',
      [SPANISH]: 'Preguntas Aleatorias:',
    },
    treatedIndividually: false,
    required: false,
    toggleAction: {
      onEnable: {
        confirmationModal: true,

        updater: ({ questions, ...questionGroup }) => ({
          ...questionGroup,
          questions: (questions || [])
            .filter(({ type }) => type !== QUESTION_TYPES.formula)
            .map((question, index) => ({
              ...question,
              logic: {
                conditions: [],
                default: getLastIndex(questions) === index ? 'finish' : 'next',
              },
            })),
        }),
        modalText: {
          [PORTUGUESE]:
            'Randomizar as perguntas <strong>excluirá a lógica de todas as perguntas</strong> do grupo e todas as perguntas de "fórmula". Tem certeza?',
          [ENGLISH]:
            'Randomizing the questions will <strong>delete the logic of all questions</strong> in the group and all "formula" questions. Are you sure?',
          [SPANISH]:
            'Aleatorizar las preguntas <strong>eliminará la lógica de todas las preguntas</strong> del grupo y todas las preguntas de "fórmula". ¿Está seguro?',
        },
      },

      onDisable: {
        confirmationModal: false,
        updater: ({ advancedOptions, ...questionGroup }) => {
          const { max_questions_to_show: _, ...options } = advancedOptions

          return {
            ...questionGroup,
            advancedOptions: options,
          }
        },
      },
    },
  },

  max_questions_to_show: {
    type: 'number',
    displayText: {
      [PORTUGUESE]: 'Máximo de Perguntas para Mostrar:',
      [ENGLISH]: 'Max Questions to Show:',
      [SPANISH]: 'Preguntas Máximas para Mostrar:',
    },
    treatedIndividually: false,
    required: false,
    minValue: 1,
    shouldDisplayChecker: ({ advancedOptions }) => {
      return advancedOptions?.randomize_questions
    },

    validator: ({ currentValue = 0, groupQuestions }) => {
      return validateMaxQuestionShow(currentValue, groupQuestions)
    },
  },
}

function validateMaxQuestionShow(currentValue, groupQuestions) {
  if (currentValue === '' || currentValue < 1) return ''

  const questions = groupQuestions.questions.length

  let maxQuestionsToShow = currentValue

  if (currentValue > questions) maxQuestionsToShow = questions

  return maxQuestionsToShow
}
